function deriveLanguageAndCountryFromLocale(locale: string): [string, string] {
  return locale.split('-') as [string, string];
}

let locale = navigator.language;
let localeLanguage: string;
let localeCountry: string;

[localeLanguage, localeCountry] = deriveLanguageAndCountryFromLocale(locale);

if ('onlanguagechange' in window) {
  window.onlanguagechange = () => {
    locale = navigator.language;
    [localeLanguage, localeCountry] =
      deriveLanguageAndCountryFromLocale(locale);
  };
}

export function getLocaleLanguage(): string {
  return localeLanguage;
}

export function getLocaleCountry(): string {
  return localeCountry;
}
